<mat-sidenav-container class="sidenav-container" fullscreen>
  <mat-sidenav #sidenav mode="side" class="sidenav safely-sidenav-expanded" fixedInViewport="true" opened="true">
    <app-sidebar [isExpanded]="isExpanded"></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content" [style.margin-left.px]="!isExpanded ? 30 : 208">
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
    <div *ngIf="showVersion" class="app-version">
      <span>v{{ version }}</span>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>